<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 3.5H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2l.01-12c0-1.1-.9-2-2-2Zm0 14H3v-12h18v12Z"
    />
  </svg>
</template>
